import { UserScorecardsState, UserScorecardsFilters } from './interfaces';

export const initialFilters: UserScorecardsFilters = {
  userName: '',
  careerMentorIds: null,
};

export const userScorecardsInitialState: UserScorecardsState = {
  items: [],
  loading: false,
  filters: { ...initialFilters },
  pagination: {
    limit: 0,
    page: 1,
    total: 0,
  },
  init: false,
  fullData: {},
  careerMentorOptions: [],
  hasSharedScorecards: false,
};

export const storeName = 'userScorecards' as const;

export type UserScorecardsStoreName = typeof storeName;
